import { ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { NEXT_PUBLIC_CDN_URL, NEXT_PUBLIC_CDN_PREFIX, NEXT_PUBLIC_SSR_TAG } from "@/shared/envs"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Resolves the path to a static asset, using versioned CDN URL if available, otherwise falling back to SSR path.
 *
 * @param path - The path to the static asset (e.g., '/static/siteLogo.svg')
 * @returns The full URL to the asset (versioned CDN or local path)
 *
 * @example
 * // Returns 'https://cdn.darpiano.com/prod_nextjs/v1.2.3/public/static/siteLogo.svg' in production
 * // Returns '/static/siteLogo.svg' in development
 * getStaticAssetPath('/static/siteLogo.svg')
 */
export function getStaticAssetPath(path: string): string {
  // Remove leading slash if present for consistent path construction
  const normalizedPath = path.startsWith('/') ? path.substring(1) : path;

  // If CDN URL, prefix, and SSR tag are configured, use versioned CDN path
  if (NEXT_PUBLIC_CDN_URL && NEXT_PUBLIC_CDN_PREFIX && NEXT_PUBLIC_SSR_TAG) {
    const url = NEXT_PUBLIC_CDN_URL.endsWith('/') ? NEXT_PUBLIC_CDN_URL.slice(0, -1) : NEXT_PUBLIC_CDN_URL;
    const prefix = NEXT_PUBLIC_CDN_PREFIX.endsWith('/') ? NEXT_PUBLIC_CDN_PREFIX.slice(0, -1) : NEXT_PUBLIC_CDN_PREFIX;
    return `${url}/${prefix}/${NEXT_PUBLIC_SSR_TAG}/public/${normalizedPath}`;
  }

  // Otherwise use the local path
  return `/${normalizedPath}`;
}

export async function formatDate(input: string | number): Promise<string> {
  const date = new Date(input)
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })
}
